// Copyright (c) 2020, 37.78 Tecnologia Ltda. All rights reserved.

/**
 * Reports errors to GCP Cloud Logging (Stackdriver)
 *
 * Usage:
 *  - `import './errorHandler';` somewhere near startup to enable automatic reporting of uncaught errors
 *  - `errorHandler.setUser('userId')` to identify current user context
 *  - `errorHandler.report(new Error())` to manually report
 *
 */

import StackdriverErrorReporter from "stackdriver-errors-js";

console.log("env", process.env.NODE_ENV);
const REMOTE_REPORT_ENABLED =
  process.env.NODE_ENV === "production" &&
  !!process.env.REACT_APP_STACKDRIVER_API_KEY;

const localHandler = {
  report: window.console.error,
  setUser: () => null,
  start: () => null,
};

const errorHandler = REMOTE_REPORT_ENABLED
  ? new StackdriverErrorReporter()
  : localHandler;

errorHandler.start({
  key: process.env.STACKDRIVER_API_KEY,
  projectId: process.env.STACKDRIVER_PROJECT_ID,
  service: process.env.APP_NAME,
  version: process.env.VERSION,
});

export default errorHandler;
